<template>

    <cms-view class="view-action-form" v-spinner="pageLoading" :hide="pageLoading">
        <div v-if="actionLogger && project">

            <cms-heading :title="pageTitle"></cms-heading>

            <cms-form-panel submit-button="Opslaan" :cancel-button="true" :submitting="submitting" @submit="submit">

                <cms-form-input title="Logger" name="logger" v-model.trim="actionLogger.serialNumber" disabled="true"></cms-form-input>
                <cms-form-input title="Projectcode" name="project" v-model.trim="project.code" disabled="true"></cms-form-input>
                <cms-form-input title="Projectleider" name="projectLeader" v-model.trim="project.projectManager" disabled="true"></cms-form-input>

                <cms-form-dropdown title="Status" name="state" v-model="pendingAction.state" :options="stateOptions" v-if="userIsAdmin"
                                   v-validate="'required'" data-vv-as="Status" :error="error('state')" data-vv-name="state"></cms-form-dropdown>

                <cms-form-row title="Meetpunt">
                    <input class="input-normal"
                           autocomplete="off"
                           type="text"
                           name="measuringPoint"
                           v-model.trim="pendingAction.measuringPoint"
                           @blur="onMeasuringPointBlur" />
                </cms-form-row>

                <cms-form-row title="Locatie">
                    <div class="places-holder">
                        <gmap-autocomplete class="input-normal" @place_changed="setPlace" @blur="onLocationBlur"
                                           :value="pendingAction.locationTitle" :select-first-on-enter="true" :disabled="locationAutoSelected"
                                           ref="autocompleteInput" />
                        <cms-button v-if="locationAutoSelected" @click="switchLocationManual()">Wijzigen</cms-button>
                    </div>
                </cms-form-row>

                <cms-form-input class="has-edit-button" title="Meetfrequentie" name="measuringFrequency" :disabled="measuringFrequencyAutoSelected" v-model.trim="pendingAction.measuringFrequency">
                    <cms-button v-if="measuringFrequencyAutoSelected" @click="switchMeasuringFrequencyManual()">Wijzigen</cms-button>
                </cms-form-input>

                <cms-form-input class="has-edit-button" title="Zendfrequentie" name="transmissionFrequency" :disabled="transmissionFrequencyAutoSelected" v-model.trim="pendingAction.transmissionFrequency">
                    <cms-button v-if="transmissionFrequencyAutoSelected" @click="switchTransmissionFrequencyManual()">Wijzigen</cms-button>
                </cms-form-input>

                <cms-form-checkbox title="Categorieën kantoor" name="categories" :options="categoryOptions" v-model="pendingAction.categories"></cms-form-checkbox>

                <cms-form-textarea title="Opmerkingen kantoor" name="commentsOffice" v-model.trim="pendingAction.commentsOffice"></cms-form-textarea>

                <cms-form-checkbox title="Categorieën veld" name="categoriesField" :options="categoryFieldOptions" v-model="pendingAction.categoriesField"></cms-form-checkbox>

                <cms-form-textarea title="Opmerkingen veld" name="commentsField" v-model.trim="pendingAction.commentsField"></cms-form-textarea>

                <cms-form-date-picker title="Datum van probleem" name="issueDate" v-model="pendingAction.issueDate" input="true" :options="{ disableMobile: true }"
                                      v-validate="'required'" data-vv-as="Datum van probleem" :error="error('issueDate')" data-vv-name="issueDate"></cms-form-date-picker>

                <cms-form-row title="Deadline van probleem" v-if="!pendingAction.issueDate">Kies eerst datum van probleem</cms-form-row>
                <cms-form-date-picker v-else title="Deadline van probleem" name="deadlineDate" v-model="deadlineDate" input="true" :options="{ disableMobile: true }"
                                      v-validate="'required'" data-vv-as="Deadline van probleem" :error="error('deadlineDate')" data-vv-name="deadlineDate"></cms-form-date-picker>

            </cms-form-panel>

        </div>
    </cms-view>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import di from 'di'
    import gql from 'graphql-tag';

    import moment from 'moment'

    import pick from 'lodash/pick'
    import clone from 'lodash/clone'
    import map from 'lodash/map'
    import get from 'lodash/get'
    import isNaN from 'lodash/isNaN'

    import ActionState from 'app/enums/ActionState'
    import ActionCategory from 'app/enums/ActionCategory'

    import LoggerQueries from 'app/queries/LoggerQueries'
    import ActionQueries from 'app/queries/ActionQueries'

    import ActionMutations from 'app/mutations/ActionMutations'

    import actionDeadlineDateFilter from "app/filters/actionDeadlineDate";
    import getMapsAddressInfo from "app/helpers/getMapsAddressInfo";

    @Component({

        name: 'action-form',
        apollo: {

            action: ActionQueries.find({

                skip(){
                    return !this.$route.params.id;
                },

                result(result){

                    if(!result || !result.data){
                        return
                    }

                    const action = result.data.viewer.findAction;

                    this.pendingAction = pick(action, ['state', 'categories', 'categoriesField', 'measuringPoint', 'commentsOffice', 'commentsField',
                        'issueDate', 'alarmDeactivated', 'measuringFrequency', 'transmissionFrequency', 'deadline', 'locationTitle', 'locationLat', 'locationLng']);
                    this.actionLogger = action.logger;
                    this.project = action.project;

                    if(this.isResolveMode){

                        this.pendingAction.state = ActionState.RESOLVED;

                        if(!this.pendingAction.commentsField){
                            this.pendingAction.commentsField = `${this.$user.initials} ${moment().format('L')}: `;
                        }
                    }

                    this.fetchMunisenseGroupLocations();
                },

                variables(){

                    return {
                        actionId: this.itemId
                    }
                }
            }),

            actionLogger: LoggerQueries.find({

                skip(){
                    return !this.$route.params.loggerId;
                },

                result(result){

                    if(!result || !result.data){
                        return
                    }

                    const logger = result.data.viewer.findLogger;

                    if(logger.openActions.itemCount > 0){

                        this.onLoggerHasActiveAction(true);
                    }
                    else {

                        if(logger.activeAllocation){

                            this.project = logger.activeAllocation.project;
                            this.fetchMunisenseGroupLocations();
                        }
                        else {

                            this.$toast.error('De logger is momenteel niet gekoppeld aan een project, het is daarom niet mogelijk om een actie aan te maken');
                            this.$router.go(-1);
                        }
                    }
                },

                variables(){

                    return {

                        loggerId: this.loggerId,
                        actionFilter: null,
                        mutationSortField: null,
                        mutationSortDirection: null
                    }
                }
            })
        }
    })
    export default class extends Vue
    {
        data(){

            return {

                action: null,
                pendingAction: {

                    state: ActionState.PENDING,
                    categories: [],
                    categoriesField: [],
                    measuringPoint: null,
                    commentsOffice: null,
                    commentsField: null,
                    measuringFrequency: null,
                    transmissionFrequency: null,
                    issueDate: null,
                    alarmDeactivated: null,
                    deadline: null,
                    locationTitle: null,
                    locationLat: null,
                    locationLng: null
                },

                actionLogger: null,
                project: null,
                addressInfo: null,
                locationAutoSelected: false,
                measuringFrequencyAutoSelected: false,
                transmissionFrequencyAutoSelected: false,

                submitting: false,
                submitted: false,
                fetchingLocation: false,

                loading: 0,
                fetchingMunisense: false
            }
        }

        breadcrumb(){

            return [{
                title: 'Acties',
                route: {
                    name: 'actions'
                }
            }, this.pageTitle];
        }

        created(){

            this.logger = this.$logger.child('ActionForm');
            this.listenerSet = false;
        }

        updated(){

            const $autocomplete = this.$refs.autocompleteInput;
            if($autocomplete && !this.listenerSet){

                $autocomplete.$el.addEventListener('keydown', (event) => {

                    // Prevent form submission on enter
                    if(event.keyCode === 13){
                        event.preventDefault();
                    }
                });

                $autocomplete.$el.addEventListener('blur', this.onLocationBlur);

                this.listenerSet = false;
            }
        }

        onQueryError(error){

            this.logger.error(error);
            this.$toast.error('De gegevens konden niet worden opgehaald');
        }

        onLoggerHasActiveAction(navigate){

            this.$toast.error('Er is nog een openstaande actie voor deze logger, los deze eerst op');

            if(navigate) {
                this.$router.go(-1);
            }
        }

        onMeasuringPointBlur(){

            if(this.pendingAction.measuringPoint){
                this.selectMunisenseLocation();
            }
        }

        onLocationBlur(){

            const title = this.$refs.autocompleteInput.$el.value;
            if(!title){
                this.clearLocation();
            }
        }

        clearLocation(){

            this.pendingAction.locationTitle = null;
            this.addressInfo = null;
        }

        setPlace(place) {

            this.pendingAction.locationTitle = this.$refs.autocompleteInput.$el.value;
            this.addressInfo = getMapsAddressInfo(place);
        }

        switchLocationManual(){

            this.locationAutoSelected = null;
            this.clearLocation();
        }

        switchMeasuringFrequencyManual(){

            this.measuringFrequencyAutoSelected = false;
        }

        switchTransmissionFrequencyManual(){

            this.transmissionFrequencyAutoSelected = false;
        }

        async fetchMunisenseGroupLocations(){

            if(!this.project.munisenseGroupId){
                return;
            }

            this.fetchingMunisense = true;

            const munisense = di.get('munisense');
            try {

                const locations = await munisense.getGroundwaterLocations(this.project.munisenseGroupId);
                this.logger.info(`Loaded Munisense locations`);

                this.groupLocations = locations;

                // Check auto selected
                const selectedLocation = this.findMunisenseLocation();

                if(selectedLocation){

                    if(selectedLocation.location_latitude === this.pendingAction.locationLat && selectedLocation.location_longitude === this.pendingAction.locationLng){
                        this.locationAutoSelected = true;
                    }

                    if(this.getFormattedDuration(parseInt(selectedLocation.analog_sample_time_expected)) === this.pendingAction.measuringFrequency){
                        this.measuringFrequencyAutoSelected = true;
                    }

                    if(this.getFormattedDuration(parseInt(selectedLocation.connect_cycle_expected)) === this.pendingAction.transmissionFrequency){
                        this.transmissionFrequencyAutoSelected = true;
                    }
                }
            }
            catch(e){

                this.logger.error('Error loading munisense locations', e);
                this.$toast.error('De Munisense locaties konden niet worden geladen');
            }

            this.fetchingMunisense = false;
        }

        selectMunisenseLocation(){

            const location = this.findMunisenseLocation();
            if(location){

                const sampleTime = parseInt(location.analog_sample_time_expected);
                const connectCycle = parseInt(location.connect_cycle_expected);

                const hasSampleTime = sampleTime && !isNaN(sampleTime);
                const hasConnectCycle = connectCycle && !isNaN(connectCycle);

                this.pendingAction.locationTitle = location.location_description;
                this.addressInfo = {
                    latitude: location.location_latitude,
                    longitude: location.location_longitude
                }

                this.locationAutoSelected = true;

                if(hasSampleTime){

                    this.pendingAction.measuringFrequency = this.getFormattedDuration(sampleTime);
                    this.measuringFrequencyAutoSelected = true;
                }

                if(hasConnectCycle){

                    this.pendingAction.transmissionFrequency = this.getFormattedDuration(connectCycle);
                    this.transmissionFrequencyAutoSelected = true
                }

                this.logger.info(`Selected location for ${location.id}`);
            }
            else {
                this.$toast.warning('Het ingevoerde meetpunt kon niet worden gevonden in de Munisense portal');
            }
        }

        getFormattedDuration(duration){

            if(!duration || isNaN(duration)){
                return null;
            }

            const durationMins = Math.round(duration / 60);

            if(durationMins < 60){
                return durationMins + ' minuten';
            }
            else {
                return Math.round(durationMins / 60) + ' uur';
            }
        }

        findMunisenseLocation(){

            if(!this.groupLocations || !this.pendingAction.measuringPoint){
                return null;
            }

            const point = this.pendingAction.measuringPoint.toLowerCase();

            return Object.values(this.groupLocations).find(location => location.description.toLowerCase() === point) || null;
        }

        get deadlineDate(){

            if(!this.pendingAction.issueDate){
                return null;
            }

            if(this.actionLogger){

                const loggerDeadline = get(this.actionLogger, 'activeAllocation.actionDeadline');
                const projectDeadline = get(this.actionLogger, 'activeAllocation.project.actionDeadline');
                const deadline = this.pendingAction.deadline || loggerDeadline || projectDeadline || this.$config.defaultActionDeadline;

                return actionDeadlineDateFilter(deadline, this.pendingAction.issueDate);
            }
            else {

                return actionDeadlineDateFilter(this.pendingAction.deadline, this.pendingAction.issueDate);
            }
        }

        set deadlineDate(date){

            if(!date || !this.pendingAction.issueDate){
                this.pendingAction.deadline = null;
                return;
            }

            const deadlineDate = moment(date);
            const issueDate = moment(this.pendingAction.issueDate);

            this.pendingAction.deadline = Math.max(deadlineDate.diff(issueDate, 'days'), 1);
        }

        get pageTitle(){

            var pageTitle = null;

            if(this.itemId){
                pageTitle = 'Actie wijzigen';
            }
            else {
                pageTitle = 'Actie toevoegen';
            }

            return pageTitle;
        }

        get isResolveMode(){

            return this.mode === 'resolve';
        }

        get itemId(){

            return this.$route.params.id;
        }

        get loggerId(){

            return this.$route.params.loggerId;
        }

        get mode(){

            return this.$route.params.mode;
        }

        get stateOptions(){

            return ActionState.options();
        }

        get categoryOptions(){

            return ActionCategory.officeOptions();
        }

        get categoryFieldOptions(){

            return ActionCategory.fieldOptions();
        }

        get userIsAdmin(){

            return this.$user.role == 'ADMIN';
        }

        get pageLoading(){

            return this.loading || this.fetchingMunisense;
        }

        error(field){

            return this.submitted ? this.errors.first(field) : null;
        }

        submit(){

            this.submitted = true;

            this.$validator.validateAll().then(success => {

                if (!success) {

                    this.$toast.error('Er zijn één of meerdere fouten');
                    return;
                }

                this.submitting = true;
                const locationText = this.$refs.autocompleteInput.$el.value;

                var actionData = clone(this.pendingAction);

                if(this.addressInfo) {

                    actionData.locationLat = this.addressInfo.latitude ? this.addressInfo.latitude : null;
                    actionData.locationLng = this.addressInfo.longitude ? this.addressInfo.longitude : null;
                }
                else if(!locationText) {

                    actionData.locationTitle = null;
                    actionData.locationLat = null;
                    actionData.locationLng = null;
                }

                if(this.action) {

                    actionData.id = this.action.id;

                    ActionMutations.update(actionData).then(() => {

                        this.logger.info('Action updated');
                        this.$toast.success('De actie is opgeslagen');

                        this.submitting = false;

                        this.$router.push({
                            name: 'action-view',
                            params: { id: this.action.id }
                        });

                    }).catch(e => this.handleSubmitError(e));
                }
                else {

                    actionData.loggerId = this.actionLogger.id;
                    actionData.projectId = this.project.id;

                    ActionMutations.create(actionData).then((response) => {

                        this.logger.info('Action created');
                        this.$toast.success('De actie is aangemaakt');

                        this.submitting = false;

                        this.$router.push({
                            name: 'actions'
                        });

                    }).catch(e => this.handleSubmitError(e));
                }
            });
        }

        handleSubmitError(e){

            const errors = map(e.graphQLErrors, 'message');
            this.logger.error('Error saving action', e);

            if(errors.indexOf('logger-action-active') >= 0){
                this.onLoggerHasActiveAction(false);
            }
            else {
                this.$toast.error('De actie kon niet worden opgeslagen');
            }

            this.submitting = false;
        }
    }

</script>
